import Main from '@/main';
import { IAccountPageApplication } from 'interfaces/account-page-application.interface';
import { RenderViewCommand } from 'interfaces/commands/render-view-command';

export class AccountPageApplication implements IAccountPageApplication {
	public renderPage(command: RenderViewCommand): void {
		Main.renderPage(command);
	}
}
